import React from 'react';
import { Search, X } from 'lucide-react';

const TABS = [
  { key: 'svi', label: 'Svi' },
  { key: 'in_progress', label: 'Aktivni' },
  { key: 'cancelled', label: 'Arhivirani' },
  { key: 'completed', label: 'Zaključeni' },
];

const NegotiationFilters = ({ search, onSearchChange, activeTab, onTabChange }) => {
  return (
    <div className="space-y-3 mb-6">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Pretraži po učesnicima, predmetu..."
          value={search}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full pl-9 pr-9 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        {search && (
          <button onClick={() => onSearchChange('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="flex gap-2 flex-wrap">
        {TABS?.map((tab) => (
          <button
            key={tab?.key}
            onClick={() => onTabChange(tab?.key)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              activeTab === tab?.key
                ? 'bg-blue-600 text-white' :'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
          >
            {tab?.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NegotiationFilters;
